import { Divider, Typography } from "@mui/material";
import i18nPackage from "../../i18n/i18n";

export default function CoreDividerWithText({
	children = i18nPackage.t("coreComponents.divider.OR"),
	className,
	orientation = "horizontal",
}: {
	children?: string;
	className?: string;
	orientation?: "horizontal" | "vertical";
}) {
	return (
		<Divider role="separator" aria-label={children} orientation={orientation}>
			<Typography component="span" className={className}>
				{children}
			</Typography>
		</Divider>
	);
}
